import * as React from "react";
import { useSelector } from "react-redux";

import { ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { FrameFactories } from "@com.mgmtp.a12.client/client-core/lib/core/frame";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";

import { CustomProgressIndicator } from "../../component/CustomProgressIndicator";

import { createViewProvider } from "../container-factory";
import { customLayoutProvider } from "../layout/layout-factory";
import { customRegionUiProvider } from "../provider/regionUiProvider";

const ProgressIndicator: ReturnType<View.ProgressComponentProvider> = function ProgressIndicator(props) {
	const dataHolders = useSelector(ActivitySelectors.activityPropById(props.activityId, it => it.dataHolders));
	const busyState = dataHolders?.some(dataHolder => dataHolder.busy);
	return <CustomProgressIndicator hide={!busyState}>{props.children}</CustomProgressIndicator>;
};

const progressComponentProvider: View.ProgressComponentProvider = () => ProgressIndicator;

export function AuthenticatedPage(): React.ReactNode {
	const state = useSelector(x => x);
	const rootRegionRef = React.useMemo(() => [], []);
	const RegionUi = React.useMemo(() => FrameFactories.regionUiProvider(rootRegionRef), [rootRegionRef]);
	const viewProvider = React.useMemo(() => createViewProvider(state), []);

	return (
		<RegionUi
			key="region"
			regionReference={rootRegionRef}
			layoutProvider={customLayoutProvider}
			regionUiProvider={customRegionUiProvider}
			viewProvider={viewProvider}
			progressComponentProvider={progressComponentProvider}
		/>
	);
}
